export default "/images/c67c44b446b93890943762116f6c1b41.avif";